import {useContext, useEffect, useRef, useState} from 'react'
import {useParams} from 'react-router-dom'
import {Button, Dropdown, Flex, Tooltip} from 'antd'
import {
    DownloadOutlined,
    DownOutlined,
    FolderOpenOutlined,
    InfoCircleOutlined,
    ThunderboltOutlined,
} from '@ant-design/icons'
import {getRequest, postRequest} from '../../services/base'
import {NavContext} from '../../context/global_context'
import {downloadErrorLogs} from '../../utils/common'
import {ProgresSpinner} from './ProgresSpinner'
import DtcValidationRunner from './DtcValidationRunner'
import {useIntl} from 'react-intl'

const DtcValidationButton = ({ actionsLabel, extraMenuItems = [] }) => {
  const intl = useIntl()
  const { vehicle } = useParams()
  const [, navDispatch] = useContext(NavContext)
  const [enableValidationBtn, setEnableValidationBtn] = useState(true)
  const [dtcValidationLogs, setDtcValidationLogs] = useState([])
  const [progressMessage, setProgressMessage] = useState('')
  const runnerRef = useRef()

  useEffect(() => {
    checkValidationFetchingProgress()
  }, [])

  const checkValidationFetchingProgress = async () => {
    let res = await getRequest(`/api/dtc_validation/status/${vehicle}/`)
    setDtcValidationLogs(res?.data?.logs)
    if (res?.data?.validation_result_status) {
      setEnableValidationBtn(false)
      setProgressMessage(
        res?.data?.current_step ||
          intl.formatMessage({ id: 'dtcValidation.processingFiles' })
      )
      setTimeout(() => {
        checkValidationFetchingProgress()
      }, 30000)
    } else {
      setEnableValidationBtn(true)
      setProgressMessage('')
    }
  }

  const fetchValidatedRecords = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'dtcValidation.fetchingRecords' }),
        showLoader: true,
      },
      notification: {},
    })
    let res = await postRequest(`/api/dtc_validation/fetch-data/`, {
      vehicle: vehicle,
    })
    navDispatch({
      type: 'loader',
      data: {
        showLoader: false,
      },
      notification: {},
    })
    if (res?.status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({
            id: 'dtcValidation.fetchRecordsSuccess',
          }),
        },
      })
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'dtcValidation.fetchRecordsError' }),
        },
      })
    }
  }

  const menuItems = []

  if (enableValidationBtn) {
    if (dtcValidationLogs?.length > 0) {
      menuItems.push({
        key: 'download_logs',
        icon: <DownloadOutlined />,
        label: intl.formatMessage({ id: 'dtcValidation.downloadLogs' }),
      })
    }
    menuItems.push({
      key: 'fetch_records',
      icon: <FolderOpenOutlined />,
      label: intl.formatMessage({ id: 'dtcValidation.fetchRecords' }),
    })
    menuItems.push({
      key: 'run_validation',
      icon: <ThunderboltOutlined />,
      label: intl.formatMessage({ id: 'dtcValidation.runValidation' }),
    })
    menuItems.push(...extraMenuItems)
  }

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case 'download_logs':
        downloadErrorLogs(dtcValidationLogs, 'error-logs.txt')
        break

      case 'fetch_records':
        fetchValidatedRecords()
        break

      case 'run_validation':
        runnerRef.current?.openModal()
        break

      default:
        break
    }
  }

  return (
    <>
      {enableValidationBtn ? (
        <Dropdown
          trigger={['click']}
          placement="bottomRight"
          menu={{ items: menuItems, onClick: handleMenuClick }}
        >
          <Button className='dtc-mapping-validation-actions-dropdown'>
            <Flex justify='space-between' className='full-width'>{actionsLabel} <DownOutlined /></Flex>
          </Button>
        </Dropdown>
      ) : (
        <Tooltip title={progressMessage} placement="bottom">
          <span style={{ cursor: 'not-allowed' }}>
            <Button disabled>
              <ProgresSpinner
                caption={intl.formatMessage({
                  id: 'dtcValidation.processingFiles',
                })}
              />
              <InfoCircleOutlined style={{ marginLeft: 8 }} />
            </Button>
          </span>
        </Tooltip>
      )}

      <DtcValidationRunner
        ref={runnerRef}
        checkValidationFetchingProgress={() => {
          checkValidationFetchingProgress()
        }}
      />
    </>
  )
}

export default DtcValidationButton
